<div [class.pb-4]="!showOnlyChips">
     @if (hasActiveFilters && !showOnlyPanel) {
     <div class="flex items-center gap-2 flex-wrap">
          @for (filter of appliedFilters; track filter.key) {
          <p-chip [label]="filter.label + ': ' + filter.value" [removable]="true" (onRemove)="removeFilter(filter)">
          </p-chip>
          }
          <button pButton type="button" icon="pi pi-filter-slash" label="Clear All Filters" 
               class="p-button-outlined highlighted-button" (click)="clearAllFilters()">
          </button>
     </div>
     }
     @if (isFilterVisible && !showOnlyChips) {
     <div class="p-4 bg-gray-50 rounded border border-gray-200 mt-3" [formGroup]="codeFilterForm">
          <!-- ROW 1 -->
          <div class="flex gap-4 mb-4 flex-wrap">
               <div class="flex flex-col gap-2" style="width: 120px;">
                    <label for="code" class="text-sm font-normal">Code:</label>
                    <p-iconfield>
                         <p-inputicon class="pi pi-search" />
                         <input id="code" type="text" pInputText formControlName="code" placeholder="Search" />
                    </p-iconfield>
               </div>
               <div class="flex flex-col gap-2 flex-1" style="min-width: 250px;">
                    <label for="shortDescription" class="text-sm font-normal">Short Description:</label>
                    <p-iconfield>
                         <p-inputicon class="pi pi-search" />
                         <input id="shortDescription" type="text" pInputText formControlName="shortDescription"
                              placeholder="Search" />
                    </p-iconfield>
               </div>
               <div class="flex flex-col gap-2" style="width: 240px;">
                    <label class="text-sm font-normal">CMS Effective Start-End Date:</label>
                    <p-datepicker formControlName="cmsEffectiveStartDateRange" dateFormat="mm/dd/yy"
                         selectionMode="range" placeholder="mm/dd/yyyy - mm/dd/yyyy" [showIcon]="true"
                         [readonlyInput]="true" [showButtonBar]="true" styleClass="w-full"
                         ariaLabel="CMS Effective Start-End Date" [appendTo]="'self'">
                    </p-datepicker>
               </div>
               <div class="flex flex-col gap-2" style="width: 240px;">
                    <label class="text-sm font-normal">Plan Effective Start-End Date:</label>
                    <p-datepicker formControlName="planEffectiveStartDateRange" dateFormat="mm/dd/yy"
                         selectionMode="range" placeholder="mm/dd/yyyy - mm/dd/yyyy" [showIcon]="true"
                         [readonlyInput]="true" [showButtonBar]="true" styleClass="w-full"
                         ariaLabel="Plan Effective Start-End Date" [appendTo]="'self'">
                    </p-datepicker>
               </div>
          </div>
          <!-- ROW 2 -->
          <div class="flex gap-4 mb-4 flex-wrap">
               <div class="flex flex-col gap-2" style="width: 350px;">
                    <label for="modifiers" class="text-sm font-normal">Modifier(s):</label>
                    <p-multiSelect id="modifiers" formControlName="modifiers" [options]="modifierOptions"
                         optionLabel="label" optionValue="value" placeholder="Select" display="comma"
                         styleClass="w-full" ariaLabel="Modifier(s)" [filter]="false" [appendTo]="'self'">
                    </p-multiSelect>
               </div>
               <div class="flex flex-col gap-2" style="width: 130px;">
                    <label for="delegated" class="text-sm font-normal">Delegated:</label>
                    <p-select id="delegated" formControlName="delegated" [options]="booleanOptions" optionLabel="label"
                         optionValue="value" placeholder="Select"
                         styleClass="w-full" ariaLabel="Delegated" [appendTo]="'self'">
                    </p-select>
               </div>
               <div class="flex flex-col gap-2" style="width: 130px;">
                    <label for="paRequired" class="text-sm font-normal">PA Required:</label>
                    <p-select id="paRequired" formControlName="paRequired" [options]="booleanOptions"
                         optionLabel="label" optionValue="value" placeholder="Select"
                         styleClass="w-full" ariaLabel="PA Required" [appendTo]="'self'">
                    </p-select>
               </div>
               <div class="flex flex-col gap-2" style="width: 130px;">
                    <label for="paAllowed" class="text-sm font-normal">PA Allowed:</label>
                    <p-select id="paAllowed" formControlName="paAllowed" [options]="booleanOptions" optionLabel="label"
                         optionValue="value" placeholder="Select"
                         styleClass="w-full" ariaLabel="PA Allowed" [appendTo]="'self'">
                    </p-select>
               </div>
               <div class="flex flex-col gap-2" style="width: 240px;">
                    <label class="text-sm font-normal">Modifier Effective Start-End Date:</label>
                    <p-datepicker formControlName="modifierEffectiveStartDateRange"
                         dateFormat="mm/dd/yy" selectionMode="range" placeholder="mm/dd/yyyy - mm/dd/yyyy"
                         [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true" styleClass="w-full"
                         ariaLabel="Modifier Effective Start-End Date" [appendTo]="'self'">
                    </p-datepicker>
               </div>
               <div class="flex flex-col gap-2" style="width: 150px;">
                    <label for="status" class="text-sm font-normal">Modifier Status:</label>
                    <p-select id="status" formControlName="status" [options]="statusOptions" optionLabel="label"
                         optionValue="value" placeholder="Select"
                         styleClass="w-full" ariaLabel="Modifier Status" [appendTo]="'self'">
                    </p-select>
               </div>
               <div class="flex flex-col gap-2" style="width: 400px;">
                    <label for="formId" class="text-sm font-normal">Associated Form ID:</label>
                    <p-iconfield>
                         <p-inputicon class="pi pi-search" />
                         <input id="formId" type="text" pInputText formControlName="formId" placeholder="Search" />
                    </p-iconfield>
               </div>
               <div class="flex flex-col gap-2" style="width: 250px;">
                    <label for="formTitle" class="text-sm font-normal">Associated Form Title:</label>
                    <p-iconfield>
                         <p-inputicon class="pi pi-search" />
                         <input id="formTitle" type="text" pInputText formControlName="formTitle" placeholder="Search" />
                    </p-iconfield>
               </div>
               <div class="flex flex-col gap-2" style="width: 150px;">
                    <label for="sharedForm" class="text-sm font-normal">Shared Form:</label>
                    <p-select id="sharedForm" formControlName="sharedForm" [options]="booleanOptions"
                         optionLabel="label" optionValue="value" placeholder="Select"
                         styleClass="w-full" ariaLabel="Shared Form" [appendTo]="'self'">
                    </p-select>
               </div>
               <div class="flex flex-col gap-2" style="width: 180px;">
                    <label class="text-sm font-normal">Form Effective Start Date:</label>
                    <p-datepicker formControlName="formEffectiveStartDate" dateFormat="mm/dd/yy"
                         placeholder="mm/dd/yyyy" [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true"
                         styleClass="w-full" ariaLabel="Form Effective Start Date" [appendTo]="'self'">
                    </p-datepicker>
               </div>
          </div>
          <!-- ACTIONS -->
          <div class="flex justify-end gap-3 pt-3 mt-2 border-t border-gray-200">
               <button pButton type="button" label="Cancel" severity="secondary" [outlined]="true"
                    class="!text-gray-700"
                    (click)="cancelFilters()">
               </button>
               <button pButton type="button" label="Apply Filters" [disabled]="!isApplyEnabled"
                    (click)="applyFilters()">
               </button>
          </div>
     </div>
     }
</div>